import { api } from '../../lib/api-client';

/**
 * Status numérico del Project (shortlist) tal como lo expone el backend
 * (ver `Scouting.Model.ProjectStatus`):
 *   0 Draft (no visible al cliente — el backend lo filtra)
 *   1 Shared
 *   2 Closed
 *   3 Archived (no visible al cliente — el backend lo filtra)
 *
 * El backend SOLO devuelve Shared y Closed; cualquier otro valor que aparezca
 * es señal de drift entre FE y BE.
 */
export type ShortlistStatus = 1 | 2;

export type ShortlistListItem = {
  /**
   * `Project.PublicKey` (Guid v7) — el backend nunca expone la PK secuencial al
   * cliente (SW-407 / ADR-007). Usar SIEMPRE como external ID en URLs y caches.
   */
  id: string;
  name: string;
  sharedAt: string; // ISO datetime
  status: ShortlistStatus;
  candidateCount: number;
};

export type ShortlistsResponse = {
  items: ShortlistListItem[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
};

export type GetShortlistsParams = {
  pageNumber?: number;
  pageSize?: number;
};

export async function getShortlists(params: GetShortlistsParams = {}): Promise<ShortlistsResponse> {
  const search = new URLSearchParams();
  if (params.pageNumber !== undefined) search.set('pageNumber', String(params.pageNumber));
  if (params.pageSize !== undefined) search.set('pageSize', String(params.pageSize));
  const query = search.toString();
  const url = query ? `/api/client/shortlists?${query}` : '/api/client/shortlists';
  return api.get<ShortlistsResponse>(url);
}
